import React from "react";
import "./style.scss";
import ZaufanieRadom from "./hooksZaufanie/radomJump";
import ZaufanieWarszawa from "./hooksZaufanie/warszawaJump";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import useConfirmationData from "./useConfirmationData";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import { HiOutlineDownload, HiOutlineTicket } from "react-icons/hi";
import EAButton from "../shared/Buttons/EAButton";

const PurchaseSuccess: React.FC = () => {
  const { loading, confirmationData, getConfirmationDocument, getConfirmationTickets, facilityIds } =
    useConfirmationData();
  const { t } = useTranslation();
  const startPageUrl = useSelector((state: State) => state.config.configuration.startPageUrl);
  const messageSummary = useSelector((state: State) => state.config.configuration.message_summary);

  const handleClickStartAgain = () => {
    window.open(startPageUrl, "_parent");
  };

  return (
    <div className="purchase-complited">
      <LoadableComponent loading={loading}>
        <div className="purchase-complited-start">
          <h1>{t("platnosc_przebiegla_pomyslnie")}</h1>
          <p>{t("twoje_bilety_powinny_pojawic_sie_wkrotce_na_adresie_email")}</p>
          {messageSummary && (
            <>
              {messageSummary.length > 12 ? (
                <div className="alert alert-comment">
                  <article dangerouslySetInnerHTML={{ __html: messageSummary }}></article>
                </div>
              ) : (
                <p></p>
              )}
            </>
          )}
          <div className="flex-start-center purchase-complited-buttons">
            {confirmationData.containsTickets && (
              <EAButton
                title={`${t("pobierz_bilety")} (PDF)`}
                onClick={() => getConfirmationTickets()}
                endIcon={<HiOutlineTicket />}
              />
            )}
            {confirmationData.containsInvoice && (
              <EAButton
                title={t("pobierz_potwierdzenie")}
                onClick={() => getConfirmationDocument()}
                endIcon={<HiOutlineDownload />}
                variant="outlined"
              />
            )}
          </div>
          <EAButton title={t("zacznij_zakupy_od_nowa")} onClick={() => handleClickStartAgain()} variant="text" />
        </div>
      </LoadableComponent>

      {facilityIds === "1200" && (
        <>
          <ZaufanieRadom />
        </>
      )}
      {facilityIds === "1204" && (
        <>
          <ZaufanieWarszawa />
        </>
      )}
    </div>
  );
};

export default PurchaseSuccess;
